import React, { useRef, useEffect } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
// those imports are important
import {
  ForwardButton,
  RewindButton,
} from "./vjs-controls/ForwardRewindButton";

function VideoJS({
  currentWorkshopIndex,
  vjsOptions,
  onVideoStart,
  onVideoEnd,
  onVideoUpdate,
  video,
}) {
  const videoRef = useRef(null);
  const playerRef = useRef(null);

  /**
   * Set player time +15s
   * @param {} e 
   * @returns 
   */
  const fwdClick = (e) => {
    playerRef.current.currentTime(playerRef.current.currentTime() + 15);
    return;
  };
  /**
   * Set player time -15s
   * @param {} e 
   * @returns 
   */
  const rwdClick = (e) => {
    playerRef.current.currentTime(playerRef.current.currentTime() - 15);
    return;
  };

  /**
   * Fire on component render once
   * Register VJS buttons
   */
  useEffect(() => {

    videojs.registerComponent(
      "backward",
      RewindButton({
        handleClick: rwdClick,
      })
    );

    videojs.registerComponent(
      "forward",
      ForwardButton({
        handleClick: fwdClick,
      })
    );
   
  }, []);

  const onReady = (player) => {
    let evts = ["timeupdate", "play", "ended", "pause", "seeking", "error"];
    player.off(evts);
    playerRef.current = player;
    /**
     * Update the video on the users account every 10% of the video
     */
    player.on("timeupdate", (e) => onVideoUpdate(player, e, currentWorkshopIndex));

    /**
     * When the video starts, update user account
     */
    player.on("play", (e) => onVideoStart(player, e));
    /**
     * When video ends, update user account
     */
    player.on("ended", (e) => onVideoEnd(player, e, currentWorkshopIndex));

    // HSS Events
    let nonce = document.getElementById("_wpnonce").value;
    let jwplayer_version = video?.jwplayer_version;
    let hss_video_id = video?.hss_video_id;
    var videoreferrer = encodeURI(window.location.href);
    let playersessionid = video?.playersessionid;
    let agent = navigator.userAgent.toLowerCase();
    let userId = video?.userid;
    let suid = video?.suid[0];

    player.on("ended", function () {
      fetch(
        "https://eventsapi.hoststreamsell.com/v1/logevent/ping.gif?player=" +
          jwplayer_version +
          "&videoid=" +
          hss_video_id +
          "&event=ended&referrer=" +
          videoreferrer +
          "&playersessionid=" +
          playersessionid +
          "&browser=" +
          agent +
          "&userid=" +
          userId +
          "&suid=" +
          suid +
          "&file=" +
          player.currentSrc(),
        {
          mode: "no-cors",
        }
      );
    });

    player.on("play", function () {
      document.querySelector('.vjs-play-control').classList.add('vjs-playing');
      fetch(
        "https://eventsapi.hoststreamsell.com/v1/logevent/ping.gif?player=" +
          jwplayer_version +
          "&videoid=" +
          hss_video_id +
          "&event=play&referrer=" +
          videoreferrer +
          "&playersessionid=" +
          playersessionid +
          "&browser=" +
          agent +
          "&userid=" +
          userId +
          "&suid=" +
          suid +
          "&file=" +
          player.currentSrc(),
        {
          mode: "no-cors",
        }
      );
    });

    player.on("pause", function () {
      document.querySelector('.vjs-play-control').classList.remove('vjs-playing');
      fetch(
        "https://eventsapi.hoststreamsell.com/v1/logevent/ping.gif?player=" +
          jwplayer_version +
          "&videoid=" +
          hss_video_id +
          "&event=pause&referrer=" +
          videoreferrer +
          "&playersessionid=" +
          playersessionid +
          "&browser=" +
          agent +
          "&userid=" +
          userId +
          "&suid=" +
          suid +
          "&file=" +
          player.currentSrc(),
        {
          mode: "no-cors",
        }
      );
    });

    player.on("seeking", function () {
      fetch(
        "https://eventsapi.hoststreamsell.com/v1/logevent/ping.gif?player=" +
          jwplayer_version +
          "&videoid=" +
          hss_video_id +
          "&event=seeking&referrer=" +
          videoreferrer +
          "&playersessionid=" +
          playersessionid +
          "&browser=" +
          agent +
          "&userid=" +
          userId +
          "&suid=" +
          suid +
          "&file=" +
          player.currentSrc() +
          "&offset=" +
          player.currentTime().toFixed(2),
        {
          mode: "no-cors",
        }
      );
    });

    player.on("error", function (event) {
      event.stopImmediatePropagation();

      var error = this.player().error();

      fetch(
        "https://eventsapi.hoststreamsell.com/v1/logevent/ping.gif?player=" +
          jwplayer_version +
          "&videoid=" +
          hss_video_id +
          "&event=error&referrer=" +
          videoreferrer +
          "&playersessionid=" +
          playersessionid +
          "&browser=" +
          agent +
          "&userid=" +
          userId +
          "&suid=" +
          suid +
          "&file=" +
          player.currentSrc() +
          "&message=" +
          error.message +
          "&code=" +
          error.code +
          "&offset=" +
          player.currentTime().toFixed(2),
        {
          mode: "no-cors",
        }
      );
    });
  };

  useEffect(() => {
    let player = null;
    // make sure Video.js player is only initialized once
    if (!playerRef.current) {
      const videoElement = videoRef.current;
      if (!videoElement) return;

      player = playerRef.current = videojs(videoElement, vjsOptions, () => {
        onReady && onReady(player);
      });
      player.getChild("controlBar").addChild("backward", {});
      player.getChild("controlBar").addChild("forward", {});
      
    } else {
      player = playerRef.current;
      // player.reset();
      player.src(vjsOptions.sources);
      onReady(player);
    }
    
  }, [vjsOptions, videoRef]);

  /**
   * Dispose the Video.js player when the functional component unmounts
   */
  useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player) {
        player.dispose();
        // playerRef.current = null;
        playerRef = null;
        videoRef = null;
      }
    };
  }, [playerRef]);

  return (
    <div data-vjs-player>
      <video ref={videoRef} className="video-js vjs-big-play-centered" style={{cursor:"pointer"}} />
    </div>
  );
}

export default VideoJS;
